<template>
  <div id="gamepage" :class="theme">
    <div class="infobar"><div class="subbar"><h1>{{name}}</h1><div class="gameBlock">
      <a v-if="ttsLink" class="tts" :href="ttsLink" target="_blank"><div class="small">Play on</div>Tabletop Simulator</a>
      <a v-else-if="itchLink" class="itch" :href="itchLink" target="_blank">Play at itch.io</a>
    </div></div></div>
    <div class="pageContent">
      <div class="mainBlock">
        <div class="gridPage">
      <div class="block" v-for="(item) in content" v-bind:key="item.id" :class="item.flex" >
        <div class="image" v-if="item.image" :class="item.float"><img :src="item.image" /></div>
        <div class="vidBlock" :class="item.float" v-if="item.video"><video autoplay loop muted playsinline>
          <source :src="item.video" type="video/webm"/>
          <source :src="item.videoAlt" type="video/mp4"/>
        </video></div>
        <div class="team" v-if="item.team"><h2>The Team</h2>
        <div class="memberbox" v-for="(item) in item.team" v-bind:key="item.id"><b class="name">{{ item.member }}</b>:  {{ item.roles }}</div></div>
        <div class="textbox" v-for="(item) in item.text" v-bind:key="item.id"><h2 class="header" v-if="item.head">{{ item.head }}</h2><span class="subsec" v-html="item.text"></span></div></div>
      </div></div>
      <div class="sidebar">
        <a v-if="ttsLink" :href="ttsLink" target="_blank"><i class="fas fa-play-circle"></i></a>
        <a v-else-if="itchLink" :href="itchLink" target="_blank"><i class="fas fa-play-circle"></i></a>
        <a v-if="ttsLink != null && itchLink != null" :href="itchLink" target="_blank"><i class="fas fa-download"></i></a>


        <ShareNetwork
            network="facebook"
            :url="urlPath"
            :title="name"
            :description="description"
        >
          <i class="fab fa-facebook-square"></i>
        </ShareNetwork>

        <ShareNetwork
            network="twitter"
            :url="urlPath"
            :title="name"
            :description="description"
        >
          <i class="fab fa-twitter-square"></i>
        </ShareNetwork>

      </div>
    </div>
</div>
</template>

<script>

export default {
  name: "gamePage",
  props: {
    urlPath: String,
    itchLink: String,
    ttsLink: String,
    name: String,
    description: String,
    photo: Image,
    logo: String,
    vid: String,
    vidAlt: HTMLVideoElement,
    theme: String,
    content: Array,
    text: Array,
    ind:String
  }
}
</script>

<style scoped>

.block {
  margin: 1em auto;
}
.fa-play-circle{
margin-left:-1px;}
video{
  display:inline;
  margin:0 auto;
  border: .5em solid var(--secondlight);
  width:100%;
  margin:-1em;
}

.gameBlock{
  display:flex;
  flex-direction:column;
  justify-content: center;
font-size:1em;
  align-items: center;
}

.subbar
{
  display:flex;
  width:100%;
  justify-content: space-between;
}

.small {
  font-size: 0.75em;
}

.tts{  width:180px;}

.itch{
  width:110px;
}


.gameBlock a{
  font-family: lemonmilk;
  font-display: swap;
  display:block;
  border: .25em solid var(--darkbg);
  outline: .2em solid var(--second);
  padding:0.35em 1.2em;
  text-decoration:none;
  text-align:center;
  color:var(--second);
  transition: all 0.2s;
}
.gameBlock a:hover{
  color:var(--secondlight);
  background: var(--second);
  border: .25em solid var(--second);

}

.sidebar {
  flex: 1;
  max-height: 6em;
  padding-left: 15px;
  border-left: solid 3px var(--second);
  font-size: 24px;
  position: -webkit-sticky;
  position: sticky;

  margin-left: 1em;
  top: 11.5rem;
}

.sidebar .share-network-facebook{
  display:block;
  width:25px;
}
.sidebar i{
  color:var(--second);
  margin-bottom:8px;
  display: block;
}

.sidebar a{
  text-decoration: none;
}

.sidebar i:hover{
  color:var(--primarylight);
  cursor:pointer;
}

b.name{
  font-size:12px;
  letter-spacing:.1em;
  text-transform: uppercase;
}

.memberbox{
  margin-bottom:.1em;
}

.mainBlock{flex: 0 1 940px;
max-width:940px;}

.gridPage{
  display:grid;
  grid-template-columns: 30% 70%;
  grid-auto-flow: column dense;
  grid-auto-rows: min-content;
margin-bottom:9em;}

.vidBlock{display:flex;padding:1em;}

.one{
  height:80%;

}
.two{
  width:90%;
  grid-column-start: 2;}
.last{
}


.image img{
  border: .5em solid var(--secondlight);
  width:100%;
  margin:-1em;
}

.image{padding:1em;}

.textbox{
  margin-bottom:1em;
}

#gamepage{
  display:flex;
  flex-grow:1;
  color:black;
  font-family: 'montserrat';
  overflow-y:scroll;
  flex-direction:column;
  align-items: stretch;
  height:100vh;
  font-size:14px;
}

.biggertext{
  flex: 2;
  display:flex;
  flex-direction: column;
}

.infobar{

  position: -webkit-sticky;
  position: sticky;
  top: 0;
  background: var(--secondlight);
  padding: 0 50px;
  flex: 0 0 150px;
  display:flex;
  flex-direction: column;
  justify-content: center;
}

.infobar h1{
  font-family: 'lemonmilk';
  font-display: swap;
  font-size: 2em;
  vertical-align: top;
  letter-spacing:.1em;
  text-align: left;
  margin:0.25em 0em;
  color: var(--second);
}

.pageContent h2{
  margin-bottom:5px;
  margin-top:0;
  font-family: lemonmilk;
  font-display: swap;
  font-size:1rem;
  letter-spacing: .2em;
}

.pageContent{
  display:flex;
  flex-direction:row;
  flex:1;

  padding:0px 50px;
  margin-top:30px;
}


#gamepage::-webkit-scrollbar-track {
  background: var(--second);
  border: 4px solid var(--darkbg)!important;
  border-radius: 10px;
}

#gamepage::-webkit-scrollbar-thumb {
  background: var(--darkbg);
  border: 4px solid var(--second);
}

-webkit-scrollbar:hover{
  cursor:pointer;
}

#gamepage::-webkit-scrollbar-thumb:hover {
  background: var(--second);
  border: 4px solid var(--seconddark);
}

#gamepage::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background: var(--second);}



</style>